/**
 * created by han guo qi
 * 上传视频弹窗(本地上传,资源库)
 */
import React, {Component} from 'react';
import { Modal, Tabs, Tooltip} from "antd";
import VideosLocally from "./VideosLocally";
import {rmtMessage} from "../../components/mess"
class UploadVideo extends Component {

    static defaultProps = {
        maxSize: 120,  // 120MB
        limitDuration: true
    };

    constructor(props) {
        super(props);
        this.state={
            videoRestrictionTypes: ["avi", "mp4", "mov", "mkv", "rmvb", "flv", "rm", "mpeg", "mpg", "ogv", "wmv", "webm"],
            visible:false,
            zykFileList:[],//资源库数据
            uploadFileList:[],//本地上传数据
            mediaId:'',
            call: () => {},
            cancelCall:()=>{},
            atlasList:[]
        }
    }

    render = () => {
        let {videoRestrictionTypes,visible} = this.state;
        let videoRestrictionType = videoRestrictionTypes.filter((item) => {
            return item
        });
        return (
            <Modal
                centered={true}
                title="本地上传"
                visible={visible}
                destroyOnClose = {true}
                onOk={() => {
                    let newZykList = this.state.zykFileList.map(item=>({
                        ...item,
                        url: item.icon
                    }));
                    let atlasList = [...this.state.uploadFileList, ...newZykList];
                    this.state.atlasList=atlasList;
                    // console.log(this.state.atlasList)
                    if (this.state.atlasList.length == 0) {
                         rmtMessage.warning('请上传一个视频！');
                        return false;
                    }
                    if(this.state.atlasList[0].status==="uploading"){
                        rmtMessage.warning("正在上传，请稍等。");
                        return false;
                    }
                    if(typeof this.state.call == 'function') {
                        this.state.call(atlasList)
                    }
                    // console.log(this.state.atlasList[0].duration/1000/60)
                    // if((this.state.atlasList[0].duration/1000/60)>15){
                    //     rmtMessage.warning("不可发布超过15分钟的视频。");
                    //     return false;
                    // }
                    this.hide()
                    console.log(atlasList,'================atlasList')
                }}
                onCancel={() => {
                    this.setState({visible:false})
                    if(typeof this.state.cancelCall == 'function') {
                        this.state.cancelCall()
                    }
                }}
                maskClosable={false}
                width={800}
                wrapClassName='renderUpload'
            >
                <div className="interval">
                    <div style={{padding: 24}}>
                        <Tooltip placement="right"
                                 title={videoRestrictionTypes ? videoRestrictionType.join(", ") : null}>
                            <span style={{color: '#F56C6C'}}>仅支持avi，mp4，mov，mkv，rmvb，flv等格式视频</span>
                        </Tooltip>
                        <VideosLocally maxSize={this.props.maxSize} limitDuration={this.props.limitDuration} onChange={(uploadFileList) => {
                            this.setState({uploadFileList})
                        }}/>
                    </div>
                    <style>
                        {`
                         .renderUpload .interval .ant-tabs-bar{padding: 0px 32px;}
                         .renderUpload .interval .ant-tabs-tab {
                               font-size: 16px;
                               font-family: Microsoft YaHei;
                               font-weight: 400;
                               line-height: 22px;
                               color: #0050B3;
                               padding: 12px 0;
                          }
                          .renderUpload .ant-modal-body {
                            padding:10px 0 
                          }
                    `}
                    </style>
                </div>
            </Modal>
        )
    };

    show = (call) => {
        this.setState({visible:true,call})
    };

    hide = () => {
        this.setState({visible:false})
    };

    empty=(cancelCall)=>{
        this.setState({cancelCall})
    }
}

UploadVideo.propTypes = {};

export default UploadVideo;
